import React from 'react';
import { Badge, Text } from 'native-base';
import { ScrollView, TouchableOpacity, useState } from 'react-native';

export default function YearsHorizontalPills(props) {
	let yScrollView = React.createRef();
	return (
		<ScrollView
			horizontal
			ref={yScrollView}
			onContentSizeChange={(contentWidth, contentHeight) => {
				yScrollView && yScrollView.scrollToEnd && yScrollView.scrollToEnd({ animated: false });
				//console.log(this.scrollView);
			}}
			style={{ flexDirection: 'row' }}>
			{props.years &&
				props.years.map((item, i, items) => (
					<Badge key={`b-${i}`} info={item.taxyear != props.currYear} primary={item.taxyear == props.currYear}>
						<TouchableOpacity onPress={() => props.setYear(item.taxyear)}>
							<Text>{item.text}</Text>
						</TouchableOpacity>
					</Badge>
				))}
		</ScrollView>
	);
}
